export const CLOSE_BUILD_PLATE_CHECK_MODAL = 'CLOSE_BUILD_PLATE_CHECK_MODAL';
export const SHOW_BUILD_PLATE_CHECK_MODAL = 'SHOW_BUILD_PLATE_CHECK_MODAL';
export const SET_SHOW_MAKERBOT_DETECTED_MODAL = 'SET_SHOW_MAKERBOT_DETECTED_MODAL_MODAL';
export const SET_DETECTED_MAKERBOT_FILES = 'SET_DETECTED_MAKERBOT_FILES'
export const SET_SHOW_BLOCKER_ALERT = 'SET_SHOW_BLOCKER_ALERT'


export const SETTINGS_INPUT_ERROR = 'SETTINGS_INPUT_ERROR';
